import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function MobileDetailingPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Mobile Auto Detailing',
    serviceType: 'Mobile Car Detailing',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Ventura County', 'Camarillo', 'Oxnard', 'Ventura', 'Thousand Oaks', 'Simi Valley', 'Moorpark', 'Newbury Park', 'Westlake Village'],
    description: 'Fully mobile car detailing throughout Ventura County. We bring the detail shop to your home or office with our own water and detailing equipment. We require access to a standard electrical outlet at the service location.'
  };
  const faqs = [{
    question: 'What is mobile car detailing?',
    answer: "Mobile car detailing is a professional cleaning and restoration service that comes to you. Mike's Pro Detail brings our own water and detailing equipment to your home or office anywhere in Ventura County — no drop-off or waiting room required. We require access to a standard electrical outlet at the service location."
  }, {
    question: 'Do you bring your own water and electricity?',
    answer: 'We bring our own water and detailing equipment. We require access to a standard electrical outlet at the service location.'
  }, {
    question: 'What areas do you cover for mobile detailing?',
    answer: 'We serve all of Ventura County including Camarillo, Oxnard, Ventura, Thousand Oaks, Simi Valley, Moorpark, Newbury Park, and Westlake Village, plus parts of the San Fernando Valley.'
  }, {
    question: 'How much does mobile detailing cost?',
    answer: 'Exterior details start at $160, interior at $180, and our popular full detail at $300, with adjustments for vehicle size. Call (818) 381-9905 for an exact quote.'
  }, {
    question: 'How long does mobile detailing take?',
    answer: 'A wash and wax takes about 1.5\u20132 hours, interior detailing 2\u20133 hours, and a full detail 3\u20134 hours. We never rush — quality results take proper time.'
  }];
  const breadcrumbs = [{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/#services'
  }, {
    name: 'Mobile Detailing',
    item: 'https://www.fulldetailpro.com/services/mobile-detailing'
  }];
  return <ServicePageLayout title="Mobile Detailing Ventura County" subtitle="The detail shop that comes to you. Professional mobile car detailing at your home or office anywhere in Ventura County — no drop-off, no waiting." metaDescription="Mobile detailing in Ventura County. Mike's Pro Detail brings interior, exterior & full car detailing to your home or office. 5-star service. Call (818) 381-9905." schema={schema} faqs={faqs} breadcrumbs={breadcrumbs} data-id="element-1042" data-mp="umb4fsg21uym">
      <p data-id="element-1043" data-mp="2fy2srngc6olb">
        At Mike's Pro Detail,{' '}
        <strong data-id="element-1044" data-mp="1t7n0qjly6lz">mobile detailing in Ventura County</strong> means professional,
        showroom-quality car care delivered directly to your driveway. There's
        no need to drop your vehicle off, sit in a waiting room, or rearrange
        your day around a detail shop's hours. We bring a fully equipped
        detailing operation — complete with our own water, detailing equipment,
        and premium products — straight to your home or office, wherever you are
        in Ventura County. We require access to a standard electrical outlet at
        the service location.
      </p>

      <h2 data-id="element-1045" data-mp="3nz4kbgu1ujl3">Why Choose Mobile Car Detailing?</h2>
      <p data-id="element-1046" data-mp="3ny2z4jjbkgpn">
        Mobile car detailing in Ventura County combines the highest quality
        results with unmatched convenience. Instead of automated car washes that
        scratch and swirl your paint, our technicians hand-detail every vehicle
        with meticulous care. And because we come to you, you reclaim hours of
        your day while we transform your car on-site.
      </p>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-1047" data-mp="16rus4705bnq5">
        <li className="flex items-start" data-id="element-1048" data-mp="11shv4tfk909u">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1049" data-mp="11tjerman6v36" />
          <span data-id="element-1050" data-mp="1fs9frd0l1ewt">
            <strong data-id="element-1051" data-mp="1fsslzwgveev0">Total Convenience:</strong> We detail your car at your home,
            office, or apartment — you never have to leave.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1052" data-mp="1ppx85wapuabt">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1053" data-mp="1pom6c20tzcnc" />
          <span data-id="element-1054" data-mp="1krvqnfsxuj2g">
            <strong data-id="element-1055" data-mp="1kqaz7z1x7g8t">We Bring the Equipment:</strong> We bring our own water and
            detailing equipment. We require access to a standard electrical
            outlet at the service location.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1056" data-mp="1uj06ehqfu7yc">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1057" data-mp="28g5a4b2oiuqf" />
          <span data-id="element-1058" data-mp="28ec3uwvzaciy">
            <strong data-id="element-1059" data-mp="23hvdrx57xo38">Premium, Hand-Crafted Results:</strong> Safe wash methods
            and professional-grade products on every vehicle.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1060" data-mp="2n1aoo90by8op">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1061" data-mp="2s2zzponjymcs" />
          <span data-id="element-1062" data-mp="2e2pbktdmnlvb">
            <strong data-id="element-1063" data-mp="2e38htctx0lti">Flexible Scheduling:</strong> Including weekends, to fit
            your busy Ventura County lifestyle.
          </span>
        </li>
      </ul>

      <h2 data-id="element-1064" data-mp="2i6dhz8qiwbez">Our Mobile Detailing Services</h2>
      <p data-id="element-1065" data-mp="24cdyag8200br">
        Every service we offer is performed on-site as part of our mobile
        detailing operation. Explore each in detail:
      </p>
      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-1066" data-mp="294x955fcwhcv">
        <Link to="/services/interior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1067" data-mp="1ug10b65h70b7">
          Interior Detailing &rarr;
        </Link>
        <Link to="/services/exterior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1068" data-mp="1qcuycapebvaj">
          Exterior Detailing &rarr;
        </Link>
        <Link to="/services/full-car-detail" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1069" data-mp="3na93qswhqvlp">
          Full Car Detail &rarr;
        </Link>
        <Link to="/services/engine-bay-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1070" data-mp="ewa6lnxs946m">
          Engine Bay Detailing &rarr;
        </Link>
        <Link to="/services/headlight-restoration" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1071" data-mp="5wwwct1u4bku">
          Headlight Restoration &rarr;
        </Link>
        <Link to="/services/ceramic-coating" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1072" data-mp="2llf315whgw6c">
          Ceramic Coating &rarr;
        </Link>
      </div>

      <h2 data-id="element-1073" data-mp="1a4c4wtohuags">Serving All of Ventura County</h2>
      <p data-id="element-1074" data-mp="1a3av0sj7ru0n">
        Our mobile detailing service reaches every community in Ventura County.
        Find your city for local details and pricing:{' '}
        <Link to="/ventura-county/camarillo" data-id="element-1075" data-mp="1juxaj12l4f97">Camarillo</Link>,{' '}
        <Link to="/ventura-county/oxnard" data-id="element-1076" data-mp="1jwrlbmk56qzk">Oxnard</Link>,{' '}
        <Link to="/ventura-county/ventura" data-id="element-1077" data-mp="1osp5y52fuji5">Ventura</Link>,{' '}
        <Link to="/ventura-county/thousand-oaks" data-id="element-1078" data-mp="1tt4f0kfot4ub">Thousand Oaks</Link>,{' '}
        <Link to="/ventura-county/simi-valley" data-id="element-1079" data-mp="1tqqjkah3hqm8">Simi Valley</Link>,{' '}
        <Link to="/ventura-county/moorpark" data-id="element-1080" data-mp="1xt51mscxwmcg">Moorpark</Link>,{' '}
        <Link to="/ventura-county/newbury-park" data-id="element-1081" data-mp="3vkpuguqb25ye">Newbury Park</Link>, and{' '}
        <Link to="/ventura-county/westlake-village" data-id="element-1082" data-mp="3gfb8kls5v9t">Westlake Village</Link>.
      </p>
    </ServicePageLayout>;
}